/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import ModalShop from "../modals/ModalShop.vue";
import $ from 'jquery';

const __vue_script__ = {
  name: "ModalOffersConduit",
  components: {
    ModalShop,
  },
  computed: {
    ...mapGetters(["content", "specialOffers", "currentModalOffer", "shopById", "specialOfferById"]),
  },
  methods: {
    ...mapActions(["changeModalOffer"]),
    offerModalData(shopId) {
      const shopData = this.$store.getters.shopById(shopId);
      const offerData = this.$store.getters.specialOfferById(shopId);

      return $.extend({}, shopData, {
        title: offerData.title,
        images: offerData.images,
        content: offerData.description,
      });
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modalTabs" },
    [
      _vm.currentModalOffer
        ? _c(
            "ModalShop",
            _vm._b(
              { attrs: { variation: "offer" } },
              "ModalShop",
              _vm.offerModalData(_vm.currentModalOffer),
              false
            )
          )
        : _c("div", { staticClass: "modalMenu" }, [
            _c("div", { staticClass: "modalMenu_titleCol" }, [
              _c("h2", { staticClass: "modalMenu_title" }, [
                _vm._v(_vm._s(_vm.content.special_offers)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modalMenu_menuCol" }, [
              _c("div", { staticClass: "modalMenu_menuWrap" }, [
                _c(
                  "nav",
                  { staticClass: "modalMenu_menu modalMenu_menu-inCol" },
                  [
                    _c(
                      "ul",
                      { staticClass: "modalMenu_list" },
                      _vm._l(_vm.specialOffers, function (offer) {
                        return _c(
                          "li",
                          {
                            key: offer.businessId,
                            staticClass: "modalMenu_item",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "modalMenu_link",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.changeModalOffer(
                                      offer.businessId
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(offer.businessTitle),
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/modals/ModalOffersConduit.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__